import { Link } from "react-router-dom";
export default function WhyNairobiSection() {
  return (
    <section className="section-space bg-[#1A2B1F] text-white">
      <div className="shell purpose-grid items-center">
        <img
          className="regional-image"
          src="/assets/images/site/nairobi001-1920x900.jpg"
          alt="Nairobi skyline"
          loading="lazy"
          width="1920"
          height="900"
        />
        <div>
          <p className="eyebrow light">Our perspective</p>
          <h2>
            Anchored in Nairobi.
            <br />
            Connected by purpose.
          </h2>
          <p className="body-copy text-white/80">
            Nairobi is the intended anchor for our East African work. Our
            pan-African ambition connects people on the continent with the
            skills, experience, and relationships of the global diaspora.
          </p>
          <p className="body-copy text-white/80">
            We are building these connections step by step, with an emphasis on
            listening to local priorities and finding partners who share a
            commitment to lasting value.
          </p>
          <Link className="text-link light" to="/about">
            Get to know Harambee <span aria-hidden="true">↗</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
